/* eslint-disable no-unused-vars */
<template>
  <v-app id="login">
    <v-content>
      <v-container fluid fill-height>

        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-12 pa-3"> <!-- Cor do card de Login -->
              <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-text>
                <div class="layout column align-center">
                  <v-row>
                    <v-col md="12"><img width="80px;" :src='config.logo' /></v-col>
                  </v-row>
                  <h1>{{ config.descricao }}</h1>
                </div>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-text-field append-icon="person" name="login" label="Login" type="text" autocomplete="username"
                    v-model="user.username" :error="error" :rules="usernameRule" />
                  <v-text-field :type="hidePassword ? 'password' : 'text'"
                    :append-icon="hidePassword ? 'visibility_off' : 'visibility'" name="password" label="Password"
                    id="password" v-model="user.password" :error="error"
                    @click:append="hidePassword = !hidePassword" />
                </v-form>
              </v-card-text>
              <!-- <v-btn text style="float:right;margin-top:-30px;height:30px;font-size:11px;">Esqueste a senha?</v-btn> -->
              <br>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn block color="#006699" style="color:white;" :disabled="!formValid"
                  @click="verificaLicenca">Entrar</v-btn>
              </v-card-actions>
              <div style="text-align: center;">
                <span style="font-size:14px;color:#ccc; text-align: center; display: inline-block;">Copyright - 2025 by
                </span><span
                  style="font-size:14px;font-weight:bolder;color:#ccc; text-align: center; display: inline-block;">Softline,
                  Angola</span>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-snackbar v-model="showResult" :timeout="6000" :color="color" top>
        {{ result }}
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import swal from 'sweetalert2'
const uuidv4 = require('uuid/v4')
const ls = require('local-storage')
const macaddress = require('macaddress')
export default {
  props: {
    source: String
  },
  data: () => ({
    configInstituicao: { "instituicao": '', "sigla": '', "logotipo": '', "base_url": '', "siglainstituicao": "" },
    img: 'http://isppluena.com/readfile/logo.jpeg',
    formValid: true,
    progresso: false,
    overlay: false,
    showResult: false,
    caixaInfo: [],
    error: false,
    counter_: 0,
    result: '',
    color: 'red',
    config: { logo: 'img/logoAt.jpeg', descricao: 'ISP-Atlântida' },
    hidePassword: true,
    usernameRule: [
      // this.value.replace(/[^\d]/, ''),

      v => !!v || 'campo obrigatório.',
      v => {
        const pattern = /([^A-Za-z0-9])$/
        return !pattern.test(v) || 'Inválido.'
      }
    ],
    drawer: null,
    user: {
      username: '',
      password: ''
    },
    long: '',
    lat: ''
  }),

  computed: {
    loggedUser() {
      const user = this.$store.getters.loggedUser
      return user // this.$session.get("role")// this.$session.getAll()// this.$session.flash.get("role")
    },
    falal() {
      return ls.get('fatal')
    },

    negocio() {
      return ls.get('negocio')
    },
    getMacAdress() {
      return ls.get('macadress')
    },


  },


  created() {
    this.getConfig()
  },


  methods: {

    async getConfig() {

      try {
        if (window.location.host.includes('192.168.18.15') || window.location.host.includes('192.168.18.16')) {
          this.config = { logo: 'img/ilhaverdade.jpg', descricao: 'IMTP-ILHA DA VERDADE' }
        } else if (window.location.host.includes('isppluena.com')) {
          this.config = { logo: 'img/logo.jpeg', descricao: 'ISPP-LUENA' }
        } else if (window.location.host.includes('ispatlantida.com') || window.location.host.includes('192.168.44.10')) {
          this.config = { logo: 'img/logoAt.jpeg', descricao: 'ISP-Atlântida' }
        } else if (window.location.host.includes('ispamazozo.com')) {
          this.config = { logo: 'img/logoMazozo.jpeg', descricao: 'Polo ISP-Atl.Mazozo' }
        } else if (window.location.host.includes('bendizer.net') || window.location.host.includes('10.112.0.20')) {
          this.config = { logo: 'img/logoB.jpeg', descricao: 'IMTP - BENDIZER' }
        } else if (window.location.host.includes('financas.ilhaverdade.gereonline.com')) {
          this.config = { logo: 'img/ilhaverdade.jpg', descricao: 'IMTP-ILHA DA VERDADE' }
        } else if (window.location.host.includes('192.168.1.254')) {
          this.config = { logo: 'img/logoEsca.png', descricao: 'Escola de Saúde Castelo' }
        } else if (window.location.host.includes('192.168.1.220')) {
          this.config = { logo: 'img/logoAlpega.png', descricao: 'Escola de Saúde ALPEGA' }
        } else if (window.location.host.includes('192.168.0.254')) {
          this.config = { logo: 'img/gab.jpeg', descricao: 'GAB DO SABER' }
        } else if (window.location.host.includes('169.254.158.200')) {
          this.config = { logo: 'img/cital_logo.jpeg', descricao: 'Cital De Base' }
        } else if (window.location.host.includes('localhost')) {
          this.config = { logo: 'img/LogoGereOnline.png', descricao: 'SOFTLINE-FINANÇAS' }
        }
        else {
          this.config = { logo: 'img/LogoGereOnline.png', descricao: 'SOFTLINE-FINANÇAS' }
        }
      } catch (error) {

      }
    },
    async ObterDadosDaLicenca() {
      return await axios.post('/obter-licenca-host-local')
    },


    async verificaLicenca() {

      try {
        this.login(50)
      } catch (error) {

      } finally {

      }


    },



    async login(dias) {
      this.overlay = true

      if (!this.user.username.includes("'") && !this.user.username.includes('"') && !this.user.username.includes('-')) {
        const userCredencial =
          {
            "username": this.user.username, 
          "password": this.user.password
        }

        try {
          const textMessage = await axios.post('/login', userCredencial).then(res => res.data)
          

          // Validando se a licença está expirada
          if (textMessage.dataActual > textMessage.dataExpiracao) {
            ls.set('licencaExpirada', 1)
          } else {
            ls.set('licencaExpirada', 0)
          }

          this.overlay = false
          const loggedUser = {
            token: textMessage.token,
            idPessoa: textMessage.idPessoa,
            pkUsuario: textMessage.pkUsuario,
            role: textMessage.role,
            username: textMessage.username,
            instituicao: textMessage.instituicao,
            sigla: textMessage.sigla,
            instituicaodescricao: textMessage.instituicaodescricao,
            anolectivo: textMessage.anolectivo,
            idanolectivo: textMessage.idanolectivo,
            nomeUsuario: textMessage.nomeUsuario,
            uuid: uuidv4(),
            empresa: textMessage.empresa,
            negocio: textMessage.negocio,
            email: textMessage.email,
            emailEmpresa: textMessage.emailEmpresa,
            nif: textMessage.nif,
            provincia: textMessage.provincia,
            localidade: textMessage.localidade,
            site: textMessage.site,
            telefone: textMessage.telefone,
            integrado: textMessage.integrado,
            regime: textMessage.regime,
            regime_descricao: textMessage.regime_descricao,
            id_negocio: textMessage.id_negocio,
            macadress: textMessage.macadress,
            diasRestantes: dias,
            mudarPassword: textMessage.mudarPassword,
            urlPed: (textMessage.integrado === "1") ? "http://localhost:3001/api" : null, //https://restrito.isppluena.com/api/
            nivel: textMessage.nivel,
            descricao_role: textMessage.descricao_role,
            tipoMulta: textMessage.tipoMulta,
            descricaoAnolectivo: textMessage.descricaoAnolectivo,
            nivel_user: textMessage.nivel_user,
            dataExpiracao: textMessage.dataExpiracao,
            dataActual: textMessage.dataActual,
            fkNegocio: textMessage.fkNegocio
            // Guarda o uniqueuserid do usuário logado 
          }
          // verifica o role
          if (dias === null && textMessage.role !== 'ROLE_SPT') {
            swal.fire({ icon: 'warning', title: 'Este computador não tem uma licença de utilização activada.' })
          } else {
            this.GuardarMeses()
            this.$store.dispatch('loggedUser', loggedUser) // mando para a store.js
            this.$store.dispatch('textMessage', { 'msg': 'Parabens, você logou  com sucesso !', 'classMessage': 'msgSucess', 'timeout': 3000 })
            // this.GetUserLocation(textMessage)
            // this.countDown();

            this.$router.push('esc-welcome')
          }
        } catch (error) {
          console.log(error);
          if (error.response.status === 404) {
            swal.fire('Usuário não encontrado, <p>verifique a sua credencial</p>', '', 'warning')
          } else {
            swal.fire('informação', '<p>Erro ao tentar efectuar a operação</p>', '', 'error')
          }
        } finally {
          this.overlay = false
        }
      } else {
        this.$store.dispatch('textMessage', { 'msg': 'Inválido !', 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async verificarCaixaAberto() {
      try {
        return await axios
          .get('/verificaCaixaAberta')
          .then(res => res.data)
      } catch (error) {

      }
    },
    async CarregActividades() {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },

    async GuardarMeses() {
      try {
        this.meses = await axios
          .get('/ListarMeses-Multa')
          .then(res => res.data)
        ls.set('meses', this.meses)
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async GetUserLocation(textMessage) {
      this.$getLocation()
        .then(coordinates => {
          let location = Object.values(coordinates)

          let valores = location.toString().split(',')
          let latitude = valores[0]
          let longitude = valores[1]

          this.LoginlogsInsert(textMessage, longitude, latitude)
        })
    },

    ObterDataTimeRemote() {
      var today = new Date()
      var day = today.getDate() + ''
      var month = (today.getMonth() + 1) + ''
      var year = today.getFullYear() + ''
      var hour = today.getHours() + ''
      var minutes = today.getMinutes() + ''
      var seconds = today.getSeconds() + ''

      day = checkZero(day)
      month = checkZero(month)
      year = checkZero(year)
      hour = checkZero(hour)
      minutes = checkZero(minutes)
      seconds = checkZero(seconds)

      return (year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds)

      function checkZero(data) {
        if (data.length === 1) {
          data = '0' + data
        }
        return data
      }
    },

    async LoginlogsInsert(textMessage, longitude, latitude) {
      const params =
      {
        loginUpdate: 0,
        username: '',
        nome: textMessage.nomeUsuario,
        datain: this.ObterDataTimeRemote(),
        dataout: '',
        autor: textMessage.nomeUsuario,
        loginpkCode: ls.get('uuid'),
        instituicao: textMessage.instituicaodescricao,
        role: textMessage.role,
        latitude: latitude,
        longitude: longitude

      }

      // consumindo a API
      try {
        let msg = await axios
          .post('/InsertOrUpdateLoginLogs', params)
          .then(res => res.data)
        this.textMessage = msg
      } catch (error) {

      }
    }
  }

}
</script>
<style scoped>
#login {

  background-image: url('/img/logo.jpg ');
  background-repeat: no-repeat;
}

.corKilamba {
  background-color: #006699;
}
</style>
